import { ReactNode, useState, MouseEvent } from 'react';
import DropdownHeader from 'components/Shared/SearchFilter/DropdownHeader';
import { Popper, Button, ClickAwayListener } from '@material-ui/core';
import classnames from 'classnames';
import { useKey } from 'react-use';
import styles, { useDropdownButtonStyles, usePopperStyles } from './styles';

interface DropdownContainerProps {
  title: string;
  children?: ReactNode;
  resetsOnClose: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export default function DropdownContainer({
  title,
  children,
  resetsOnClose,
  onClick,
  disabled,
}: DropdownContainerProps): JSX.Element {
  const buttonClasses = useDropdownButtonStyles();
  const popperClasses = usePopperStyles();

  const [isMenuReset, setIsMenuReset] = useState(true);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>();
  const open = !!anchorEl;

  function handleClick(event: MouseEvent<HTMLButtonElement>): void {
    if (!disabled) {
      setIsMenuReset(false);
      setAnchorEl(event.currentTarget);
    }
  }

  function handleClose(): void {
    setAnchorEl(undefined);
    resetsOnClose ? setIsMenuReset(true) : setIsMenuReset(false);
  }

  useKey('Escape', handleClose);

  return (
    <div
      data-testid="dropdown-container"
      className={classnames(
        'dropdown-container',
        open && !disabled ? 'black-border' : undefined,
        disabled ? 'dropdownDisabled' : undefined
      )}
    >
      <Button
        classes={buttonClasses}
        aria-haspopup="listbox"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <DropdownHeader title={title} isPointedUp={open} onClick={onClick} disabled={disabled} />
      </Button>
      {!isMenuReset && (
        <ClickAwayListener onClickAway={handleClose}>
          <Popper
            anchorEl={anchorEl}
            keepMounted
            open={open}
            data-testid="dropdown-menu"
            disablePortal={true}
            placement={'bottom'}
            className={popperClasses.root}
          >
            {children &&
              [children].map((child, i) => {
                return (
                  <button className="menu-item" onClick={handleClose} key={i}>
                    {child}
                  </button>
                );
              })}
          </Popper>
        </ClickAwayListener>
      )}
      <style jsx>{styles}</style>
    </div>
  );
}
